export enum PromotionPage {
  Accounts = 'accounts',
  Contacts = 'contacts',
  Offers = 'offers',
  Orders = 'orders',
  Documents = 'documents',
}

export const DEFAULT_PROMOTION_PAGE = PromotionPage.Accounts;
